import {
  Sparkles,
  LayoutDashboard,
  Type,
  Palette,
  Ruler,
  MousePointerClick,
  Link2,
  TextCursorInput,
  CalendarDays,
  Hash,
  CheckSquare,
  CircleDot,
  Upload,
  PanelTop,
  PanelTopDashed,
  PanelBottom,
  Package,
  Tag,
  ShoppingBag,
  Boxes,
  Percent,
  Receipt,
  Grid3x3,
  Circle,
  Heading,
  PanelBottomDashed,
  Image,
  Columns2,
  Columns3,
  AlignLeft,
  BadgeCheck,
  GalleryHorizontalEnd,
  Timer,
  LayoutGrid,
  MessageSquareWarning,
  GraduationCap,
  KeyRound,
  CalendarClock,
  Bell,
  LoaderCircle,
  PanelRight,
  MessageCircleQuestion,
  Square,
  IdCard,
  ListCollapse,
  Rows3,
  ShieldCheck,
  CircleHelp,
  Box,
  Sticker,
  RectangleHorizontal,
  Images,
  Shapes,
  PanelLeft,
  PanelLeftOpen,
  SwatchBook,
  SlidersHorizontal,
  BadgeInfo,
  MessageSquareText,
  List,
  ReceiptText,
  Inbox,
  Minus,
  ListChecks,
  LayoutList,
  ChevronsRight,
  PanelTopOpen,
  ListFilter,
  FileText,
} from 'lucide-react';

import * as OverviewPage from './pages/OverviewPage';
import * as TypographyPage from './pages/foundations/TypographyPage';
import * as ColorsPage from './pages/foundations/ColorsPage';
import * as SpacingPage from './pages/foundations/SpacingPage';
import * as ButtonPage from './pages/ButtonPage';
import * as BlurRevealPage from './pages/BlurRevealPage';
import * as HyperlinkPage from './pages/HyperlinkPage';
import * as InputPage from './pages/InputPage';
import * as DatePickerPage from './pages/DatePickerPage';
import * as QuantityInputPage from './pages/QuantityInputPage';
import * as CheckboxPage from './pages/CheckboxPage';
import * as RadioButtonPage from './pages/RadioButtonPage';
import * as FileUploadPage from './pages/FileUploadPage';
import * as SliderPage from './pages/SliderPage';
import * as HeaderPage from './pages/HeaderPage';
import * as TopBarPage from './pages/TopBarPage';
import * as FooterPage from './pages/FooterPage';
import * as ProductCardPage from './pages/ProductCardPage';
import * as PricePage from './pages/PricePage';
import * as FilterPage from './pages/FilterPage';
import * as SimpleProductPage from './pages/cart/SimpleProductPage';
import * as PackageProductPage from './pages/cart/PackageProductPage';
import * as DiscountPage from './pages/cart/DiscountPage';
import * as SummaryPage from './pages/cart/SummaryPage';
import * as LabelSelectorPage from './pages/configurator/LabelSelectorPage';
import * as ColorSelectorPage from './pages/configurator/ColorSelectorPage';
import * as HeadingsPage from './pages/configurator/HeadingsPage';
import * as StickyFooterPage from './pages/configurator/StickyFooterPage';
import * as PatchCardPage from './pages/configurator/PatchCardPage';
import * as TextCardPage from './pages/configurator/TextCardPage';
import * as ImageSelectorPage from './pages/configurator/ImageSelectorPage';
import * as PatchesPage from './pages/configurator/PatchesPage';
import * as TabBarItemPage from './pages/configurator/TabBarItemPage';
import * as ProductColorSelectorPage from './pages/configurator/ProductColorSelectorPage';
import * as HeroBannerPage from './pages/content/HeroBannerPage';
import * as HeroBannerV2Page from './pages/content/HeroBannerV2Page';
import * as PatchBurstPage from './pages/content/PatchBurstPage';
import * as HeroBannerV3Page from './pages/content/HeroBannerV3Page';
import * as HeroBannerV4Page from './pages/content/HeroBannerV4Page';
import * as USPV2Page from './pages/content/USPV2Page';
import * as ContentBannerV2Page from './pages/content/ContentBannerV2Page';
import * as ContentBannerV3Page from './pages/content/ContentBannerV3Page';
import * as ContentBannerV4Page from './pages/content/ContentBannerV4Page';
import * as BentoGridPage from './pages/content/BentoGridPage';
import * as ContentBannerPage from './pages/content/ContentBannerPage';
import * as FullwidthPage from './pages/content/FullwidthPage';
import * as ProductsGridPage from './pages/content/ProductsGridPage';
import * as USPPage from './pages/content/USPPage';
import * as SecondaryBannerPage from './pages/content/SecondaryBannerPage';
import * as SecondaryBannerV2Page from './pages/content/SecondaryBannerV2Page';
import * as ContentCardPage from './pages/content/ContentCardPage';
import * as FomoBlockPage from './pages/content/FomoBlockPage';
import * as PopupPage from './pages/overlays/PopupPage';
import * as SchoolSelectorPage from './pages/overlays/SchoolSelectorPage';
import * as EditOrderLoginPage from './pages/overlays/EditOrderLoginPage';
import * as BookMeetingPage from './pages/overlays/BookMeetingPage';
import * as NotificationPage from './pages/NotificationPage';
import * as PreloaderPage from './pages/PreloaderPage';
import * as SidePanelPage from './pages/overlays/SidePanelPage';
import * as InfoTooltipPage from './pages/overlays/InfoTooltipPage';
import * as ModalPopupPage from './pages/overlays/ModalPopupPage';
import * as NavigationCardPage from './pages/NavigationCardPage';
import * as SideMenuPage from './pages/SideMenuPage';
import * as BreadcrumbsPage from './pages/BreadcrumbsPage';
import * as FAQItemPage from './pages/FAQItemPage';
import * as BulkQuantityInputPage from './pages/BulkQuantityInputPage';
import * as TurnstilePage from './pages/TurnstilePage';
import * as InfoButtonPage from './pages/configurator/InfoButtonPage';
import * as Product3DPreviewPage from './pages/Product3DPreviewPage';
import * as FormGroupPage from './pages/FormGroupPage';
import * as BadgePage from './pages/display/BadgePage';
import * as InlineNoticePage from './pages/display/InlineNoticePage';
import * as FactRowPage from './pages/display/FactRowPage';
import * as OrderCardPage from './pages/display/OrderCardPage';
import * as EmptyStatePage from './pages/display/EmptyStatePage';
import * as DividerPage from './pages/display/DividerPage';
import * as ActionListPage from './pages/display/ActionListPage';

/**
 * registry.js — the single source of truth for the design system dashboard.
 *
 * Drives the sidebar, the routes and the search index, and is what
 * `registry.test.js` walks to verify every documented prop against the real
 * component. Adding a page means adding one entry here; nothing else knows
 * the page list.
 *
 * A group is `{ id, label, items[] }`; an item is
 * `{ slug, label, icon, module }` where `module` is the page module
 * (default export = demos, named `meta` export = documentation).
 */

export const BASE_PATH = '/design-system';

export const GROUPS = [
  {
    id: 'start',
    label: null,
    items: [
      { slug: 'overview', label: 'Overview', icon: LayoutDashboard, module: OverviewPage },
    ],
  },
  {
    id: 'foundations',
    label: 'Foundations',
    items: [
      { slug: 'typography', label: 'Typography', icon: Type, module: TypographyPage },
      { slug: 'colors', label: 'Colors', icon: Palette, module: ColorsPage },
      { slug: 'spacing', label: 'Spacing & Radius', icon: Ruler, module: SpacingPage },
      { slug: 'blur-reveal', label: 'Blur Reveal', icon: Sparkles, module: BlurRevealPage },
    ],
  },
  {
    id: 'actions',
    label: 'Actions',
    items: [
      { slug: 'button', label: 'Button', icon: MousePointerClick, module: ButtonPage },
      { slug: 'hyperlink', label: 'Hyperlink', icon: Link2, module: HyperlinkPage },
    ],
  },
  {
    id: 'forms',
    label: 'Forms',
    items: [
      { slug: 'input', label: 'Input', icon: TextCursorInput, module: InputPage },
      { slug: 'datepicker', label: 'DatePicker', icon: CalendarDays, module: DatePickerPage },
      { slug: 'quantity-input', label: 'QuantityInput', icon: Hash, module: QuantityInputPage },
      { slug: 'bulk-quantity-input', label: 'BulkQuantityInput', icon: Rows3, module: BulkQuantityInputPage },
      { slug: 'slider', label: 'Slider', icon: SlidersHorizontal, module: SliderPage },
      { slug: 'checkbox', label: 'Checkbox', icon: CheckSquare, module: CheckboxPage },
      { slug: 'radio-button', label: 'RadioButton', icon: CircleDot, module: RadioButtonPage },
      { slug: 'file-upload', label: 'File Upload', icon: Upload, module: FileUploadPage },
      { slug: 'turnstile', label: 'Turnstile', icon: ShieldCheck, module: TurnstilePage },
      { slug: 'form-group', label: 'Form Group', icon: ListChecks, module: FormGroupPage },
    ],
  },
  {
    id: 'data-display',
    label: 'Data display',
    items: [
      { slug: 'badge', label: 'Badge', icon: BadgeInfo, module: BadgePage },
      { slug: 'inline-notice', label: 'Inline Notice', icon: MessageSquareText, module: InlineNoticePage },
      { slug: 'fact-row', label: 'Fact Row', icon: List, module: FactRowPage },
      { slug: 'order-card', label: 'Order Card', icon: ReceiptText, module: OrderCardPage },
      { slug: 'empty-state', label: 'Empty State', icon: Inbox, module: EmptyStatePage },
      { slug: 'divider', label: 'Divider & Swatch', icon: Minus, module: DividerPage },
      { slug: 'action-list', label: 'Action List', icon: LayoutList, module: ActionListPage },
    ],
  },
  {
    id: 'navigation',
    label: 'Navigation',
    items: [
      { slug: 'header', label: 'Header', icon: PanelTop, module: HeaderPage },
      { slug: 'top-bar', label: 'Top Bar', icon: PanelTopDashed, module: TopBarPage },
      { slug: 'footer', label: 'Footer', icon: PanelBottom, module: FooterPage },
      { slug: 'navigation-card', label: 'Navigation Card', icon: IdCard, module: NavigationCardPage },
      { slug: 'side-menu', label: 'Side Menu', icon: PanelLeftOpen, module: SideMenuPage },
      { slug: 'breadcrumbs', label: 'Breadcrumbs', icon: ChevronsRight, module: BreadcrumbsPage },
    ],
  },
  {
    id: 'commerce',
    label: 'Commerce',
    items: [
      { slug: 'product-card', label: 'Product Card', icon: Package, module: ProductCardPage },
      { slug: 'price', label: 'Price', icon: Tag, module: PricePage },
      { slug: 'product-3d-preview', label: 'Product 3D Preview', icon: Box, module: Product3DPreviewPage },
      { slug: 'filter', label: 'Filter', icon: ListFilter, module: FilterPage },
    ],
  },
  {
    id: 'shopping-cart',
    label: 'Shopping Cart',
    items: [
      { slug: 'shopping-cart/simple-product', label: 'Simple Product', icon: ShoppingBag, module: SimpleProductPage },
      { slug: 'shopping-cart/package-product', label: 'Package Product', icon: Boxes, module: PackageProductPage },
      { slug: 'shopping-cart/discount', label: 'Discount', icon: Percent, module: DiscountPage },
      { slug: 'shopping-cart/summary', label: 'Summary', icon: Receipt, module: SummaryPage },
    ],
  },
  {
    id: 'configurator',
    label: 'Configurator',
    items: [
      { slug: 'configurator/label-selector', label: 'Label Selector', icon: Grid3x3, module: LabelSelectorPage },
      { slug: 'configurator/color-selector', label: 'Color Selector', icon: Circle, module: ColorSelectorPage },
      { slug: 'configurator/headings', label: 'Headings', icon: Heading, module: HeadingsPage },
      { slug: 'configurator/info-button', label: 'Info Button', icon: CircleHelp, module: InfoButtonPage },
      { slug: 'configurator/sticky-footer', label: 'Sticky Footer', icon: PanelBottomDashed, module: StickyFooterPage },
      { slug: 'configurator/product-color-selector', label: 'Product Color Selector', icon: SwatchBook, module: ProductColorSelectorPage },
      { slug: 'configurator/image-selector', label: 'Image Selector', icon: Images, module: ImageSelectorPage },
      { slug: 'configurator/patch-card', label: 'Patch Card', icon: Sticker, module: PatchCardPage },
      { slug: 'configurator/text-card', label: 'Text Card', icon: RectangleHorizontal, module: TextCardPage },
      { slug: 'configurator/patches', label: 'Patches', icon: Shapes, module: PatchesPage },
      { slug: 'configurator/tab-bar-item', label: 'Tab Bar Item', icon: PanelLeft, module: TabBarItemPage },
    ],
  },
  {
    id: 'content-blocks',
    label: 'Content Blocks',
    items: [
      { slug: 'content-blocks/hero-banner', label: 'Hero Banner', icon: Image, module: HeroBannerPage },
      { slug: 'content-blocks/hero-banner-v2', label: 'Hero Banner V2', icon: Image, module: HeroBannerV2Page },
      { slug: 'content-blocks/hero-banner-v3', label: 'Hero Banner V3', icon: Image, module: HeroBannerV3Page },
      { slug: 'content-blocks/hero-banner-v4', label: 'Hero Banner V4', icon: Image, module: HeroBannerV4Page },
      { slug: 'content-blocks/patch-burst', label: 'Patch Burst', icon: Sparkles, module: PatchBurstPage },
      { slug: 'content-blocks/content-banner', label: 'Content Banner', icon: Columns2, module: ContentBannerPage },
      { slug: 'content-blocks/content-banner-v2', label: 'Content Banner V2', icon: Columns2, module: ContentBannerV2Page },
      { slug: 'content-blocks/content-banner-v3', label: 'Content Banner V3', icon: Columns2, module: ContentBannerV3Page },
      { slug: 'content-blocks/content-banner-v4', label: 'Content Banner V4', icon: Columns3, module: ContentBannerV4Page },
      { slug: 'content-blocks/content-card', label: 'Content Card', icon: FileText, module: ContentCardPage },
      { slug: 'content-blocks/bento-grid', label: 'Bento Grid', icon: LayoutGrid, module: BentoGridPage },
      { slug: 'content-blocks/fullwidth', label: 'Fullwidth', icon: AlignLeft, module: FullwidthPage },
      { slug: 'content-blocks/products-grid', label: 'Products Grid', icon: LayoutGrid, module: ProductsGridPage },
      { slug: 'content-blocks/secondary-banner', label: 'Secondary Banner', icon: GalleryHorizontalEnd, module: SecondaryBannerPage },
      { slug: 'content-blocks/secondary-banner-v2', label: 'Secondary Banner V2', icon: PanelTopOpen, module: SecondaryBannerV2Page },
      { slug: 'content-blocks/usp', label: 'USP', icon: BadgeCheck, module: USPPage },
      { slug: 'content-blocks/usp-v2', label: 'USP V2', icon: BadgeCheck, module: USPV2Page },
      { slug: 'content-blocks/fomo-block', label: 'Fomo Block', icon: Timer, module: FomoBlockPage },
      { slug: 'content-blocks/faq-item', label: 'FAQ Item', icon: ListCollapse, module: FAQItemPage },
    ],
  },
  {
    id: 'overlays',
    label: 'Overlays',
    items: [
      { slug: 'popup', label: 'Popup', icon: MessageSquareWarning, module: PopupPage },
      { slug: 'modal-popup', label: 'Modal Popup', icon: Square, module: ModalPopupPage },
      { slug: 'side-panel', label: 'Side Panel', icon: PanelRight, module: SidePanelPage },
      { slug: 'info-tooltip', label: 'Info Tooltip', icon: MessageCircleQuestion, module: InfoTooltipPage },
      { slug: 'school-selector', label: 'School Selector', icon: GraduationCap, module: SchoolSelectorPage },
      { slug: 'edit-order-login', label: 'Edit Order Login', icon: KeyRound, module: EditOrderLoginPage },
      { slug: 'book-meeting', label: 'Book Meeting', icon: CalendarClock, module: BookMeetingPage },
    ],
  },
  {
    id: 'feedback',
    label: 'Feedback',
    items: [
      { slug: 'notification', label: 'Notification', icon: Bell, module: NotificationPage },
      { slug: 'preloader', label: 'Preloader', icon: LoaderCircle, module: PreloaderPage },
    ],
  },
];

/** Flat page list, each carrying its group label. */
export const PAGES = GROUPS.flatMap((group) =>
  group.items.map((item) => ({ ...item, group: group.label, groupId: group.id })),
);

export const PAGE_BY_SLUG = new Map(PAGES.map((page) => [page.slug, page]));

/** Options for the top bar's searchable Input. */
export const SEARCH_OPTIONS = PAGES.map((page) => ({
  value: page.slug,
  label: page.label,
}));

export const DEFAULT_SLUG = 'overview';
